<template>
  <div :class="['FieldInput', { error: canShowError }]">
    <field-label v-if="label" :for-id="id">{{ label }}</field-label>
    <input
      :id="id"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      class="field"
      v-model="field.$model"
      :maxlength="maxlength"
    />
    <field-error :show="canShowError">{{ errorMessage }}</field-error>
  </div>
</template>

<script>
import formField from "@mixins/form-field";
import FieldLabel from "@components/form/field-label";
import FieldError from "@components/form/field-error";

export default {
  name: "FieldInput",
  components: { FieldError, FieldLabel },
  mixins: [formField],
  props: {
    type: { type: String, default: "text" },
    placeholder: { type: String, default: "" },
    maxlength: { type: Number, default: null }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.field {
  display: block;
  width: 100%;
  background: $color-white;
  border: 1px solid rgba($color-dark, 0.25);
  border-radius: 5px;
  font-size: 16px;
  line-height: normal;
  font-weight: $light;
  height: 40px;
  padding: 0 16px 1px;
  color: $color-dark;
  transition: border 0.4s ease-in-out;

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
    height: 50px;
    padding: 0 25px 2px;
  }

  &::placeholder {
    color: rgba($color-grey, 0.75);
    opacity: 1;
  }

  .error & {
    border-color: $color-error;
  }
}
</style>
